import { useState, useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { message } from 'antd'
import YzBackground from '../../../../../components/pc/YzBackground'
import AboutUsIntroduce from '../AboutUsIntroduce'
import AboutCourse from '../AboutCourse'
import AboutContactUs from '../AboutContactUs'
import AboutHonor from '../AboutHonor'
// import AboutBusiness from '../AboutBusiness'
import AUBAdvantage from '../AUBAdvantage'
import AUBTeam from '../AUBTeam'
import Footer from '../../../../../components/pc/Footer'
import BuoyBox from '../../../../../components/pc/BuoyBox'
import HTTP from '../../../../../utils/Http'
import './index.less'

const AboutUsSection = () => {
  // 菜单
  const menuList = useSelector((state) => state?.Menu?.menuList) // 菜单列表
  const [backgroud] = menuList.filter(f => f.title === '关于我们').map(m => m.backgroud)

  const [data, setData] = useState([]) // 关于我们列表
  const [loading, setLoading] = useState(false)
  const getData = async () => {  // 获取关于我们列表
    if (loading) return;
    setLoading(true)
    try {
      const res = await HTTP.postForm("/api/v1/brand/list"+`?t=${new Date().getTime()}`)
      if (res.status === 10000) {
        let target = res?.data?.filter(f => {
          return f?.key === 'company_profile' ||
          f?.key === 'develop_history' ||
          f?.key === 'footer_contact_us'
        })
        setData(target)
      } else {
        message.error({ content: res?.message, style: { marginTop: '10vh' } })
      }
    } catch (error) {
      message.error({ content: '通信失败，请检查网络后重试', style: { marginTop: '10vh' } })
    } finally {
      setLoading(false)
    }
  }
  useEffect(() => {
    getData()
  }, [])

  // 置顶
  const boxRef = useRef(null)
  const [scrollTop, setScrollTop] = useState(0)
  const [clientHeight, setClientHeight] = useState(0)
  const goToTop = () => { // 置顶事件
    let myTimer = setInterval(() => {
      boxRef.current.scrollTop -= 60
      if(boxRef.current.scrollTop<=0){
        boxRef.current.scrollTop = 0
        window.clearInterval(myTimer)
      }
    }, 10)
  }
  useEffect(() => { // 页面滚动
    window.addEventListener("scroll", (e) => {
      setScrollTop(e?.target?.scrollTop)
      setClientHeight(e?.target?.clientHeight);
    }, true)
  }, [])

  return (
    <section ref={boxRef} className='about_us_section'>
      <div className='about_us_box'>
        <YzBackground
          title='About US'
          content='关于我们'
          backgroundImage={backgroud}
          isShowButton={false}
        />
        <AboutUsIntroduce data={data[0]} />
        <AboutCourse data={data[1]} />
        <AboutHonor  />
        {/* <AboutBusiness data={data[4]} /> */}
        <AUBAdvantage />
        <AUBTeam />
        <AboutContactUs data={data[2]} />
        <Footer />
        <BuoyBox isShowTop={scrollTop > clientHeight} onTop={goToTop} />
      </div>
    </section>
  )
}

export default AboutUsSection